module.exports = __webpack_public_path__ + "static/media/519OliverStNW_2018-07-09_144.b215bbcc.jpg";